<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
  )
    template(v-if="all")
      option(value="" selected) {{ $t("ui.all") }}
    template(v-else)
      option(value="" disabled selected) {{ $t("message.select_option") }}
    option(
      v-for="option in options"
      :value="getDDLValue(option)"
      v-if="getDDLValue(option) != excludeOpt && isEnableBankAccType(option.bank_acc_type) && isEnableBankId(option.bank_id) && greaterThanZero(option.account_balance) && isActive(option.status)"
    )
      | {{ option.bank_name }} - {{ option.bank_acc_no }} - {{ option.bank_acc_holder }} ({{ $n(option.account_balance, 'currency') }})
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    excludeOpt: {
      type: String,
      default: ''
    },
    filterBankAccType: {
      type: Boolean,
      default: false
    },
    filterBalance: {
      type: Boolean,
      default: false
    },
    filterBankAccStatus: {
      type: Boolean
    },
    hideBankAccType: {
      type: Array,
      default: null
    },
    hideBankId: {
      type: Array,
      default: null
    },
    all: {
      type: Boolean,
      default: false
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted: function() {
    this.getBankAccList();
  },
  methods: {
    getDDLValue: function(obj) {
      return obj.bank_id.toUpperCase().trim() + ' - ' + obj.bank_acc_no.toUpperCase().trim() + ' - ' + obj.bank_acc_holder.toUpperCase().trim() + ' - ' + obj.account_balance.toString().toUpperCase().trim();
    },
    getBankAccList: function() {
      let url = config.bankListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        operator_id: this.operatorID,
        page_number: 1,
        page_size: -1
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    isActive(status) {
      if (this.filterBankAccStatus) {
        if (status == true)
          return true;
        else
          return false;
      }

      return true;
    },
    isEnableBankAccType(value) {
      if (this.hideBankAccType && this.hideBankAccType.length > 0) {
        if (this.hideBankAccType.includes(value))
          return false;
      }


      return true;
    },
    isEnableBankId(value) {
      if (this.hideBankId && this.hideBankId.length > 0) {
        if (this.hideBankId.includes(value))
          return false;
      }


      return true;
    },
    // filterType(bankAccType) {
    //   if (this.filterBankAccType) {
    //     if (bankAccType.toUpperCase() == 'OUTGOING' || bankAccType.toUpperCase() == 'BOTH')
    //       return true;
    //     else
    //       return false;
    //   }

    //   return true;
    // },
    greaterThanZero(balance) {
      if (this.filterBalance) {
        if (balance > 0)
          return true;
        else
          return false;
      }

      return true;
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
